import React, { type ReactElement } from 'react';
import classNames from 'classnames';
import IconDS22, { IconIds } from 'src/common/components/IconDS22';
import Typography from 'src/common/components/Typography';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './HighlightBanner.module.scss';

export type HighlightComponentProps = {
  variant: 'info' | 'success' | 'error' | 'warning' | 'neutral';
  icon: IconIds;
  title: string | ReactElement;
  subtitle?: string | ReactElement;
  body: string | ReactElement;
};

const HighlightBanner: React.FC<HighlightComponentProps> = ({
  variant = 'neutral',
  icon,
  title,
  subtitle,
  body,
}) => (
  <div className={getClassNames(styles, 'root', classNames(variant))}>
    <div className={styles.icon}>
      <IconDS22 id={icon} />
    </div>
    <div className={styles.text}>
      <div className={styles.title}>
        <Typography size="body-m" weight="semibold" type="p">
          {title}
        </Typography>
        {subtitle && (
          <Typography size="body-s" type="p">
            {subtitle}
          </Typography>
        )}
      </div>
      <Typography size="body-m" type="p" italic>
        {body}
      </Typography>
    </div>
  </div>
);

export default HighlightBanner;
